import React from 'react';
import TeamSection from '../components/sections/Team';

const Team = () => {
  return (
    <>
      <div className="page-title">
        <div className="container">
          <div className="title-wrapper">
            <h1>Our Team</h1>
            <p>Engineers, architects, and delivery leads who build with you</p>
          </div>
        </div>
      </div>
      <TeamSection />
    </>
  );
};

export default Team;
